module.exports = __webpack_public_path__ + "img/badge_first_simple.a763c352.png";